import { Injectable } from '@angular/core';
import { Subject, Observable, finalize, takeUntil, tap, timer, interval, takeWhile, delay, of, startWith, switchMap, catchError } from 'rxjs';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class ContentLoaderService {
  public messageSubject = new Subject<string>();

  constructor(private restService: RestService) {}

  submitData(apiEndpoint: string, params: any, messages: string[]): Observable<any> {
    return new Observable(observer => {
      let stopMessages = false;

      // Function to send messages
      const sendMessages = () => {
        observer.next(messages[0]); // Send the first message immediately
        interval(3000).pipe(
          takeWhile(index => !stopMessages && index < messages.length - 1),
          tap(index => {
            if (index < messages.length - 1) {
              observer.next(messages[index + 1]);
            }
          })
        ).subscribe();
      };

      // Start sending messages
      sendMessages();

      // Initiate API call immediately
      this.restService.postData(params, apiEndpoint).pipe(
        tap((data: any) => {
          stopMessages = true; // Stop sending further messages
          observer.next(data); // Send API response
          observer.complete(); // Complete the observer
        }),
        catchError(err => {
          console.error(err);
          stopMessages = true; // Stop sending further messages
          observer.error(err); // Send error to observer
          return of(err);
        }),
        finalize(() => this.messageSubject.complete()) // Complete the message subject when done
      ).subscribe();

      return () => {
        stopMessages = true;
      };
    });
  }
}